import { User, UserPermissions } from 'entities/user';
import { Action } from 'store';
import { Types } from '.';

export interface State {
  user?: User;
  permissions?: UserPermissions;
}

const InitialState: State = {
  user: undefined,
  permissions: undefined,
};

export const reducer = (state: State = InitialState, action: Action): State => {
  switch (action.type) {
    case Types.UPDATE_PREFERRED_MFA:
      return {
        user: {
          ...state.user,
          preferredMfaMethod: action.payload.preferredMFA,
        },
      };

    case Types.POPULATE_USER:
    case Types.POPULATE_PERMISSIONS:
      return {
        ...state,
        ...action.payload,
      };

    case Types.SIGN_OUT:
      return {};

    default:
      return state;
  }
};
